import GlobalErrorBoundary, {GlobalErrorBoundaryProps} from "GlobalErrorBoundary"

export default class DashboardErrorBoundary extends GlobalErrorBoundary {
  constructor(props: GlobalErrorBoundaryProps) {
    super(props)
    this.actions = []
  }
}
